import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

function HomeFleet() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <section>
      <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
        <div className="homeFleet">
          <div className="fleet">
            <h1 className={`${isVisible ? "visible" : ""}`}>
              {t("fleet_title")}
            </h1>
            <p className={`${isVisible ? "visible" : ""}`}>
              {t("fleet_text")}
            </p>
            <a
              className={`${isVisible ? "visible" : ""}`}
              href="/fleetStructure"
              reloadDocument
            >
              <button>{t("fleet_more")}</button>
            </a>
          </div>
          <div className="warehouse">
            <h1 className={`${isVisible ? "visible" : ""}`}>
              {t("warehouse_title")}
            </h1>
            <p className={`${isVisible ? "visible" : ""}`}>
              {t("warehouse_text")}
            </p>
            <a
              className={`${isVisible ? "visible" : ""}`}
              href="/warehouseStructure"
              reloadDocument
            >
              <button>{t("fleet_more")}</button>
            </a>
          </div>
        </div>
      </VisibilitySensor>
    </section>
  );
}

export default HomeFleet;
